const key = "state";

export const loadState = () => {
  const serializedState = localStorage.getItem(key);
  if (!serializedState) {
    return undefined;
  }
  return JSON.parse(serializedState);
};

export const saveState = state => {
  const serializedState = JSON.stringify(state);
  localStorage.setItem(key, serializedState);
};
